/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { ListingResponseDto } from './listingResponseDto';
import type { ListingsListMetadataDto } from './listingsListMetadataDto';

export interface ListingsListResponseDto {
  data: ListingResponseDto[];
  metadata: ListingsListMetadataDto;
}
